import Glide from '@glidejs/glide';

const mountSlider = (element) => {
	let options = {
		type: 'slider',
		startAt: 0,
		perView: 1,
		peek: 0,
		autoplay: 5000,
	};
	if (element.dataset.glideOptions) {
		options = JSON.parse(element.dataset.glideOptions);
	}
	const slider = new Glide(element, {
		...options,
		// Add default mobile behavior
		breakpoints: {
			1024: {
				autoplay: false,
				gap: 15,
				perView: 1,
				peek: {
					before: 0,
					after: 26,
				},
			},
		},
	});
	slider.mount();
};

export const mount = () => {
	Array.from(document.querySelectorAll('[data-glide-mount]')).forEach(
		(slider) => mountSlider(slider)
	);
};
